import { defineMessages } from 'react-intl';

const applePayMessages = defineMessages({
    payWithApplePay: {
        id: 'applePay.applePayMessages.payWithApplePayButton',
        description: 'Button to use Apple Pay as the payment method',
        defaultMessage: 'BUY WITH APPLE PAY'
    },
    cardSubtotalLineItem: {
        id: 'applePay.applePayMessages.cardSubtotalLineItem',
        description: 'Apple Pay line item label for the card subtotal with the number of cards being purchased',
        defaultMessage: 'Card Subtotal ({count})'
    },
    shippingLineItem: {
        id: 'applePay.applePayMessages.shippingLineItem',
        description: 'Apple Pay line item label for the shipping cost of the items being purchased',
        defaultMessage: 'Shipping'
    },
    discountLineItem: {
        id: 'applePay.applePayMessages.discountLineItem',
        description: 'Apple Pay line item label for the discount applied to the order',
        defaultMessage: 'Discount'
    },
    totalAmountLineItem: {
        id: 'applePay.applePayMessages.totalAmountLineItem',
        description: 'Apple Pay line item label for the total order cost',
        defaultMessage: '{brandName}'
    },
    firstNameRequired: {
        id: 'applePay.applePayMessages.firstNameRequired',
        description: 'Error message displayed when the first name was not provided on an Apple Pay address form',
        defaultMessage: 'Please enter your first name as it appears on your credit card'
    },
    lastNameRequired: {
        id: 'applePay.applePayMessages.lastNameRequired',
        description: 'Error message displayed when the last name was not provided on an Apple Pay address form',
        defaultMessage: 'Please enter your last name as it appears on your credit card'
    },
    cityRequired: {
        id: 'applePay.applePayMessages.cityRequired',
        description: 'Error message displayed when the city was not provided on an Apple Pay address form',
        defaultMessage: 'Please enter your billing city'
    },
    stateRequired: {
        id: 'applePay.applePayMessages.stateRequired',
        description: 'Error message displayed when the state or province was not provided on an Apple Pay address form',
        defaultMessage: 'Please enter your billing state'
    },
    postCodeRequired: {
        id: 'applePay.applePayMessages.postcodeRequired',
        description: 'Error message displayed when the postal or zip code was not provided on an Apple Pay '
        + 'address form',
        defaultMessage: 'Please enter a valid billing postal code'
    },
    phoneRequired: {
        id: 'applePay.applePayMessages.phoneRequired',
        description: 'Error message displayed when a phone number was not provided on an Apple Pay address form',
        defaultMessage: 'Please enter a valid contact phone number'
    },
    street1Required: {
        id: 'applePay.applePayMessages.street1Required',
        description: 'Error message displayed when the street address was not provided on an Apple Pay address form',
        defaultMessage: 'Please enter your billing address'
    },
    senderEmailRequired: {
        id: 'applePay.applePayMessages.senderEmailRequired',
        description: 'Error displayed when purchaser email was not provided for an Apple Pay payment',
        defaultMessage: 'Please enter a valid email'
    }
});

export default applePayMessages;
